import { RestError } from '@azure/core-http';
import { CourierAppWhoAmITestDto, CourierWhoAmIDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useMutation } from 'react-query';
import { useApi } from '../../../core/api/api.context';

export function useMutationCourierLoginTest() {
  const api = useApi();

  return useMutation<CourierWhoAmIDto, RestError, CourierAppWhoAmITestDto>(async (dto) => {
    return await api.testingController.whoamiTest(dto);
  });
}
